import React from "react";
import { clinicProfile } from "./clinicInfo";

interface ClinicPrintFooterProps {
  note?: string;
  showSignature?: boolean;
  signatureLabel?: string;
}

export default function ClinicPrintFooter({
  note,
  showSignature = false,
  signatureLabel = "Doctor's Signature",
}: ClinicPrintFooterProps) {
  return (
    <div className={`print-footer ${showSignature ? "with-signature" : ""}`}>
      {showSignature && (
        <div className="signature-block">
          <div className="signature-line" />
          <span>{signatureLabel}</span>
        </div>
      )}
      <div className="footer-details">
        <div className="footer-clinic">{clinicProfile.name}</div>
        <div className="footer-address">{clinicProfile.addressLines.join(" ")}</div>
        <div className="footer-contact">Phone: {clinicProfile.phones.join(", ")}</div>
      </div>
      {note && <div className="footer-note">{note}</div>}
    </div>
  );
}

